module.exports = __webpack_public_path__ + "static/media/siddharth-sakleshpur-trip-09.a4935f3e.png";